import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-wzb-carousel-slide',
  template: '<ng-template #slideContent><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WzbCarouselSlideComponent {
  @ViewChild('slideContent')
  slideContent!: TemplateRef<any>;
}
